import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import flatten from 'flat'
import { IntlProvider } from 'react-intl';
import useConfig from 'hooks/useConfig';
const HANDLED_LANGUAGES = ['fr', 'es', 'en', 'pt'];

// load locales files
const loadLocaleData = (locale) => {
    switch (locale) {
        case 'fr':
            return import('utils/locales/fr.json');
        case 'es':
            return import('utils/locales/es.json');
        case 'en':
            return import('utils/locales/en.json');
        case 'pt':
            return import('utils/locales/pt.json');
        default:
            return import('utils/locales/fr.json');
    }
};

// ==============================|| LOCALIZATION ||============================== //

const Locales = ({ children }) => {
    const { locale, forceLocale  } = useConfig();
    
    const [messages, setMessages] = useState();
    const [localeToUse, setLocaleToUse] = useState('fr');

    useEffect(() => {
        if (forceLocale) {
            console.log("Use the locale from the config", locale)
            setLocaleToUse(locale)
            loadLocaleData(locale).then((d) => {
                setMessages(d.default);
            });
        } else {
            const defaultLocaleOfBrowser = getBrowserLocale();
            setLocaleToUse(defaultLocaleOfBrowser)
            console.log("Use the default locale of the browser", defaultLocaleOfBrowser)
            loadLocaleData(defaultLocaleOfBrowser).then((d) => {
                setMessages(d.default);
            });
        }
    }, [forceLocale, locale, localeToUse]);

    const getBrowserLocale = () => {
        if (!navigator || !navigator.languages) return 'fr'
        const handledLocales = HANDLED_LANGUAGES.filter(x => navigator.languages.includes(x));
        return handledLocales[0] || 'fr';
    };

    console.log('localeToUse', localeToUse)
    return (
        <>
            {messages && (
                <IntlProvider locale={localeToUse} messages={flatten(messages)}>
                    {children}
                </IntlProvider>
            )}
        </>
    );
};

Locales.propTypes = {
    children: PropTypes.node
};

export default Locales;
